import React, { PropsWithChildren, useContext, useEffect, useRef } from 'react'
import { HeaderDataContext } from '../context/HeaderContext'
import { ParallaxContextProvider } from '../context/ParallaxContext'
import { WindowContext } from '../context/WindowContext'

export interface ParallaxWrapperProps {
  pageHasStickyMenu?: boolean
}

export const ParallaxWrapper = ({
  children,
  pageHasStickyMenu,
}: PropsWithChildren<ParallaxWrapperProps>) => {
  const windowRef = useRef<HTMLDivElement>(null)
  const contentRef = useRef<HTMLDivElement>(null)
  const { setBodyElement, setWindowElement } = useContext(WindowContext)
  const headerHeight = useContext(HeaderDataContext)

  let scrollPadding = headerHeight + 30

  if (pageHasStickyMenu) {
    scrollPadding += 75
  }

  useEffect(() => {
    setBodyElement(contentRef.current)
    setWindowElement(windowRef.current)

    return () => {
      setBodyElement(null)
      setWindowElement(null)
    }
  }, [windowRef, setBodyElement, setWindowElement])

  return (
    <div
      className="perspective h-screen scroll-smooth"
      ref={windowRef}
      style={{
        scrollPaddingTop: `${scrollPadding}px`,
      }}
    >
      <ParallaxContextProvider>
        <div className="ios-sticky-fix" ref={contentRef}>
          {children}
        </div>
      </ParallaxContextProvider>
    </div>
  )
}
